
<ul class="nav nav-tabs">
  <li [class.active]="tab == 'download'">
    <a href="javascript:;" (click)="tab = 'download'">{{'app.downloadTemplate' |translate}}</a>
  </li>
  <li [class.active]="tab == 'upload'">
    <a href="javascript:;" (click)="tab = 'upload'">{{'app.uploadTemplate' |translate}}</a>
  </li>

</ul>

<div class="tab-content tab-content-bordered">
  <div class="tab-pane active in" *ngIf="tab == 'download'">
    <div class="image-upload cursor-pointer margin-top-5 margin-left-44" (click)="downloadTemplate()">
      <label>
        <i class="fa fa-chevron-left" aria-hidden="true"></i>
        <i class="fa fa-arrow-down" aria-hidden="true"></i>
        <i class="fa fa-chevron-right" aria-hidden="true"></i>
      </label>
    </div>

  </div>
  <div class="tab-pane active in" *ngIf="tab == 'upload'">

    <div class="image-upload cursor-pointer margin-top-5 margin-left-44">
      <label (click)="file.click()">
        <i class="fa fa-chevron-left" aria-hidden="true"></i>
        <i class="fa fa-arrow-up" aria-hidden="true"></i>
        <i class="fa fa-chevron-right" aria-hidden="true"></i>
      </label>

      <input #file type="file" accept=".csv" style="display:none" [disabled]="loading" (change)="upload(file)" />
    </div>

    <br />
    <span style="font-weight:bold;color:blue;" *ngIf="message&&loading">
      {{message}}
    </span>

    <div *ngIf="loading" class="progress" style="height:20px;margin-top:8px;">
      <div class="progress-bar" role="progressbar" [style.width.%]="progressPercent">
        {{progressPercent}}%
      </div>
    </div>
    <span *ngIf="loading&&progressPhase" style="color:#666;">
      {{progressPhase}}
    </span>

    <span style="font-weight:bold;color:red;" *ngIf="message&&error&&!loading">
      {{message}}
    </span>

    <span style="font-weight:bold;color:green;" *ngIf="message&&!error&&!loading">
      {{message}}
    </span>

    <ul *ngIf="!loading&&details.length" style="margin-top:8px;padding-left:18px;">
      <li *ngFor="let line of details">{{line}}</li>
    </ul>

  </div>

</div>

